export default function HourGlassSimple({ className }: { className?: string }) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.1988 12.285L8.72315 8L13.1988 3.715C13.2013 3.71214 13.204 3.70942 13.2069 3.70688C13.3467 3.56702 13.4418 3.38888 13.4804 3.19496C13.5189 3.00104 13.4991 2.80005 13.4235 2.61738C13.3478 2.43471 13.2197 2.27857 13.0554 2.16868C12.891 2.05879 12.6977 2.00009 12.5 2H3.50003C3.30231 2.00009 3.10906 2.05879 2.9447 2.16868C2.78033 2.27857 2.65223 2.43471 2.57658 2.61738C2.50093 2.80005 2.48113 3.00104 2.51968 3.19496C2.55823 3.38888 2.65339 3.56702 2.79315 3.70688C2.79601 3.70942 2.79873 3.71214 2.80128 3.715L7.2769 8L2.80128 12.285C2.79873 12.2879 2.79601 12.2906 2.79315 12.2931C2.65339 12.433 2.55823 12.6111 2.51968 12.805C2.48113 12.999 2.50093 13.2 2.57658 13.3826C2.65223 13.5653 2.78033 13.7214 2.9447 13.8313C3.10906 13.9412 3.30231 13.9999 3.50003 14H12.5C12.6978 14 12.8911 13.9414 13.0556 13.8316C13.22 13.7217 13.3482 13.5656 13.424 13.3829C13.4997 13.2002 13.5196 12.9992 13.481 12.8052C13.4425 12.6112 13.3473 12.433 13.2075 12.2931C13.2044 12.2906 13.2015 12.2879 13.1988 12.285ZM9.88815 10.5H6.1119L8.00003 8.6925L9.88815 10.5ZM12.5 3L8.00003 7.3075L3.50003 3H12.5Z"
        fill="#101828"
      />
    </svg>
  );
}
